import React from "react";
import * as Icon from "react-bootstrap-icons";
import styles from "./GridEntityNameCell.module.css";
import { getGridEntityType } from "./GridEntityNameCell.utils";

interface GridEntityNameCellProps {
  data?: {
    SourceName?: string;
    SourceTaxId?: string;
    ClientName?: string;
    ClientType?: string;
  };
}

export const GridEntityNameCell: React.FC<GridEntityNameCellProps> = ({ data }) => {
  if (!data) return <></>;

  const entityName = data.SourceName ?? data.ClientName;
  const EntityIcon = getGridEntityType(data) === "individual" ? Icon.Person : Icon.BuildingsFill;

  return (
    <span className={styles.entityNameCell}>
      <span className={styles.entityIcon}>
        <EntityIcon />
      </span>
      {entityName}
    </span>
  );
};
